module.exports = __webpack_public_path__ + "img/grid-aside-bus.ac1cbee1.png";